<template>
    <MainLayout selectMenu="1-1" siderMenu="16-1" sideBar="machine">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>
            <Row class="menu-line" type="flex">
                <Col flex="2" class="menu-actions" v-if="alarm && alarm.length > 0">
                    <Button type="error" size="small"  icon="md-trash" @click.native="deleteRecord()">{{
                        getTranslation("m027")
                    }}</Button>&nbsp;
                    <Button type="info" size="small" icon="md-cloud-download" @click.native="exportRecord">{{
                        getTranslation("k025")
                    }}</Button>
                </Col>
                <Col flex="12" class="search-part">
                {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
                    :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate" format="yyyy-MM-dd">
                </DatePicker>&nbsp;
                <Input v-model="recordId" size="small" style="width:260px" :placeholder="getTranslation('r105')" />&nbsp;
                <Input v-model="alarmContent" size="small" style="width:100px" :placeholder="getTranslation('k223')" @on-enter="queryData" />&nbsp;

                <Tooltip placement="right-end" theme ="light" :transfer="true" max-width="300" >
                    <div slot="content" >
                                <div v-html="getTranslation('e035')"></div>
                            </div>
                    <Icon type="md-information-circle" color="#5cadff"  size="20"/>
                </Tooltip>
                &nbsp;
                <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">
                    <Button type="primary" size="small" @click.native="queryData()" shape="circle" icon="ios-search"></Button>
                </Tooltip>&nbsp;
                <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
                    <Button type="error" size="small"  @click.native="emptyAlarmQuery()" shape="circle"
                        icon="ios-refresh"></Button>
                </Tooltip>

                </Col>
            </Row>
            <Affix>
            <Row class="table-header" type="flex">
                <Col flex="1" class="table-cell flex-left">&nbsp;<Checkbox @on-change="handleCheckAll">
                </Checkbox>{{ getTranslation('k221') }}
                </Col>
                <Col flex="1" class="table-cell">{{ getTranslation('k222') }}
                </Col>
                <Col flex="1" class="table-cell">{{ getTranslation('b006') }}
                </Col>
                <Col flex="2" class="table-cell">{{ getTranslation('b007') }}
                </Col>
                <Col flex="1" class="table-cell">{{ getTranslation('m009') }}
                </Col>
                <Col flex="5" class="table-cell">{{ getTranslation('k223') }}
                </Col>
                <Col flex="1" class="table-cell">{{ getTranslation('k005') }}
                </Col>
            </Row>
            </Affix>
            <CheckboxGroup v-model="selectedItems">
                <Row v-for="(item,index) in alarm" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
                    <Col flex="1" class="table-cell">&nbsp;<Checkbox class="hide-label" :label="item.id"></Checkbox>
                    &nbsp;{{
                        getDate(item.created_string) }}
                    </Col>
                    <Col flex="1" class="table-cell">{{ getTime(item.created_string) }}
                    </Col>
                    <Col flex="1" class="table-cell">{{ item.ProgramId }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ item.WeldProgram }}
                    </Col>
                    <Col flex="1" class="table-cell">{{ stateMap[item.kind] }}
                    </Col>
                    <Col flex="5" class="table-cell">{{ item.content }}
                    </Col>
                    <Col flex="1" class="table-cell action-button flex-middle"><template
                        v-if="item.record_id != ''"><Button type="success" size="small" icon="ios-eye-outline"
                            @click.native="toRecord(item)">{{
                                getTranslation("r104")
                            }}</Button></template>
                    </Col>
                </Row>
                <Row type="flex" class="menu-actions">
                    
                    <Col flex="1">
                    <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
                        @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
                        :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }}
                        {{ getTranslation('c011') }}</Page>
                    </Col>
                </Row>
            </CheckboxGroup>
        </div>
    </MainLayout>
</template>
<script>

import { API_URL, PAGE_SIZE_ARY } from '@/constants/const';
import MainLayout from '@/components/MainLayout.vue'
import axios from 'axios';
import { mapState,mapGetters } from 'vuex'
import { Row, Col, Button, Input, DatePicker, Page, Checkbox, CheckboxGroup,Affix,Tooltip, Icon } from "view-design"
import { formatUTCDate, getDate, getTime, blobToString, exportFile, setSidbarBreadCrumb, postJsError, setDashboardPage } from '@/util/util.js'
import NoAuth from '@/components/NoAuth.vue'
export default {
    name: 'AlarmIndex', // 组件名称
    components: {
        MainLayout, Row, Col, Button, Input, DatePicker, Page, Checkbox, CheckboxGroup, NoAuth,Affix,Tooltip, Icon
    },
    watch: {
    },
    computed: {
        ...mapGetters(['getTranslation']),
        ...mapState(['queryDate']),
        stateMap() {
            return {
                0: this.getTranslation("k255"),
                1: this.getTranslation("k256"),
            }
        }
    },
    data() {
        return {
            alarm: [],
            total: 0,
            current: 1,
            pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
            selectDate: [new Date(),new Date()],
            kw: '',
            selectedItems: [],
            recordId: '',
            pageSizeAry: PAGE_SIZE_ARY,
            hasAuth: true,
            alarmContent:"",
        }
    },
    mounted() {

    },
    created() {
        setDashboardPage('alarm');
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            this.initMachine(),
                this.$nextTick(() => {                    
                    let start = this.$route.query.start;
                    let end = this.$route.query.end;
                    let recordId = this.$route.query.record_id;
                    if (start && end) {        
                        this.selectDate = [new Date(start),new Date(end) ]
                    } else if (this.queryDate && this.queryDate.length > 0) {
                        this.selectDate = [...this.queryDate]
                    }                    
                    
                    if (recordId) {
                        this.recordId = recordId
                    }
                    this.getData();
                })
        },
        initMachine() {
            let url = API_URL["recordInit"];
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$store.commit('setBreadcrumbItems', [
                            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
                        ]);
                    }
                })
        },
        getData() {
            let url = API_URL["alarmGet"];
            let params = {
                page: this.current,
                page_size: this.pageSize,
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                content: this.alarmContent,
                record_id: this.recordId
            }
            this.$store.commit('setQueryDate', this.selectDate)
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.alarm = res.data.data.data;
                        this.total = res.data.data.total;
                        this.pageSize = res.data.data.pagination.page_size;
                        this.current = res.data.data.pagination.page;
                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c019'));
                })
        },
        emptyAlarmQuery(){
            this.current =1;
            this.recordId ="";
            this.alarmContent ="";
            this.getData();
        },
        queryData(){
            this.current =1 
            this.getData();
        },
        getDate(str) {
            return getDate(str)
        },
        getTime(str) {
            return getTime(str)
        },
        handlePageChange(page) {
            this.current = page;
            this.getData();
        },
        handlePageSizeChange(pageSize) {
            this.current = 1;
            this.pageSize = pageSize;
            localStorage.setItem('user.page_size', this.pageSize)
            this.getData();
        },
        handleCheckAll(status) {
            if (status) {
                this.selectedItems = this.alarm && this.alarm.map(item => item.id);
            } else {
                this.selectedItems = [];
            }
        },
        deleteRecord() {
            if (this.selectedItems.length === 0) {
                this.$Message.error(this.getTranslation('b177'));
                return
            }
            this.$Modal.confirm({
                title: this.getTranslation('b135'),
                content: this.getTranslation('b180'),
                okText: this.getTranslation('m027'),
                cancelText: this.getTranslation('b182'),
                onOk: () => {
                    let url = API_URL["alarmDelete"];
                    let formData = new FormData();
                    formData.append('ids', this.selectedItems.join(','));
                    axios.post(url,
                        formData
                    )
                        .then(res => {
                            if (res && res.data && res.data.code == 200) {
                                this.selectedItems = []
                                this.$Message.success(res.data.msg);
                                this.getData();
                            } else if (res && res.data && res.data.msg) {
                                this.$Message.error(res.data.msg);
                            }
                        })
                        .catch((err) => {
                            postJsError(err)
                            this.$Message.error(this.getTranslation('c019'));
                        })
                }
            });
        },

        async exportRecord() {
            let params = {
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                record_id: this.recordId,
                content: this.alarmContent,
            }
            let exportUrl = API_URL["alarmExport"];
            const response = await axios.get(exportUrl, {
                responseType: 'blob',
                params: params,
                timeout: 300000,
            });
            if (response.status == 200) {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                        }
                    }).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    exportFile(response)
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        toRecord(item) {
            this.$router.push({
                path: '/record',
                query: {
                    mac: this.mac,
                    start: formatUTCDate(this.selectDate[0]),
                    end: formatUTCDate(this.selectDate[1]),
                    record_id: item.record_id
                }
            })
        }
    },


}
</script>
<style>
.hide-label.ivu-checkbox-wrapper>span:last-child {
    display: none;
}
</style>
<style scoped>
@import url('../../assets/style/list.css');
</style>
